import React from 'react';
import PropTypes from 'prop-types';
import ReactPlayer from 'react-player';

import Styles from './styles';

const PLAYER_VARS = {
  autoplay: 0,
  controls: 0,
  disablekb: 1,
  enablejsapi: 1,
  fs: 0,
  iv_load_policy: 3,
  loop: 1,
  modestbranding: 1,
  rel: 0
};

const ResponsivePlayer = ({
  attributes,
  fullSize,
  playbackRate,
  playerVars,
  showControls,
  url,
  onVideoReadyFunction,
  onProgressFunction,
  onPlayFunction,
  onVideoPauseFunction,
  playing,
  isNotesComponent,
  isPreviewMapEditor,
  configPlayer,
  heightDisplay,
  widthDisplay
}) => (
  <Styles.ResponsivePlayer fullSize={fullSize}>
    <ReactPlayer
      className="react-player"
      config={isNotesComponent ? configPlayer : { youtube: { playerVars }, file: { attributes } }}
      controls={showControls}
      height={heightDisplay}
      loop
      muted={isNotesComponent ? true : !showControls}
      playbackRate={playbackRate}
      playing={isNotesComponent || isPreviewMapEditor ? playing : showControls}
      url={url}
      volume={showControls ? null : 0}
      width={widthDisplay}
      onReady={onVideoReadyFunction}
      onProgress={onProgressFunction}
      onPlay={onPlayFunction}
      onPause={onVideoPauseFunction}
    />
  </Styles.ResponsivePlayer>
);

ResponsivePlayer.defaultProps = {
  attributes: {},
  fullSize: false,
  playbackRate: 1,
  playerVars: PLAYER_VARS,
  showControls: false,
  onVideoReadyFunction: () => '',
  onProgressFunction: () => {},
  playing: false,
  isNotesComponent: false,
  isPreviewMapEditor: false,
  onPlayFunction: () => {},
  onVideoPauseFunction: () => {},
  configPlayer: {},
  heightDisplay: '100%',
  widthDisplay: '100%'
};

ResponsivePlayer.propTypes = {
  attributes: PropTypes.object,
  fullSize: PropTypes.bool,
  playbackRate: PropTypes.number,
  playerVars: PropTypes.object,
  showControls: PropTypes.bool,
  url: PropTypes.string.isRequired,
  onVideoReadyFunction: PropTypes.func,
  onProgressFunction: PropTypes.func,
  playing: PropTypes.bool,
  isNotesComponent: PropTypes.bool,
  isPreviewMapEditor: PropTypes.bool,
  onPlayFunction: PropTypes.func,
  onVideoPauseFunction: PropTypes.func,
  configPlayer: PropTypes.object,
  heightDisplay: PropTypes.string,
  widthDisplay: PropTypes.string
};

export default ResponsivePlayer;
